import moment from 'moment';
// @ts-expect-error
import {createReducer} from 'redux-act';
import {REHYDRATE} from 'redux-persist';

import get from 'lodash/get';
import {isToday, isBeforeToday, isTomorrow, isAfterTomorrow} from 'nutshell-core/date-time';
import {getRehydratedValueForDateProperty} from 'nutshell-core/reducer-utils';
import _ from 'underscore';

// @ts-expect-error
import * as actions from '../../dashboard-actions';

// @ts-expect-error
import {removeItemAndShiftIndices} from '../sidebar-helpers';

import {TODAY} from './todos-constants';

const defaultTodosState = {
    items: {},
    counts: {
        total: 0,
    },
    indices: {},
    tempIds: [],
} as const;

const defaultTodosConfigState = {
    filter: '',
    queryString: '',
    displayDate: moment().startOf('day').valueOf(),
    periodSegmentWasManuallySelected: true,
    lastUpdated: null,
    periodSegmentSelected: TODAY,
} as const;

const defaultTodoState = {
    id: undefined,
    type: undefined,
    title: undefined,
    completedTime: null,
    lastUpdated: 0,
    errorMessage: undefined,
    didInvalidate: false,
    isCompleting: false,
    isUncompleting: false,
    isSkipping: false,
    isDelaying: false,
} as const;

export const todoReducer = createReducer(
    {
        // @ts-expect-error
        [actions.requestTodoCompleteData]: (state) => {
            return {...state, isCompleting: true};
        },
        // @ts-expect-error
        [actions.requestTodoUncompleteData]: (state) => {
            return {...state, isUncompleting: true};
        },
        // @ts-expect-error
        [actions.requestTodoSkipData]: (state) => {
            return {...state, isSkipping: true};
        },
        // @ts-expect-error
        [actions.requestTodoDelayData]: (state) => {
            return {...state, isDelaying: true};
        },
        // @ts-expect-error
        [actions.clearTodoError]: (state) => {
            return {...state, errorMessage: undefined};
        },
        // @ts-expect-error
        [actions.failTodoCompleteData]: (state, payload = 'Could not complete step') => {
            return {...state, isCompleting: false, errorMessage: payload};
        },
        // @ts-expect-error
        [actions.failTodoUncompleteData]: (state, payload = 'Could not uncomplete step') => {
            return {...state, isUncompleting: false, errorMessage: payload};
        },
        // @ts-expect-error
        [actions.failTodoSkipData]: (state, payload = 'Could not skip step') => {
            return {...state, isSkipping: false, errorMessage: payload};
        },
        // @ts-expect-error
        [actions.failTodoDelayData]: (state, payload = 'Could not delay step') => {
            return {...state, isDelaying: false, errorMessage: payload};
        },
        // @ts-expect-error
        [actions.updateTodoData]: (state, payload) => {
            return {
                ...state,
                isCompleting: false,
                isUncompleting: false,
                isDelaying: false,
                isSkipping: false,
                errorMessage: undefined,
                lastUpdated: new Date().getTime(),
                didInvalidate: false,
                ...payload,
            };
        },
    },
    defaultTodoState
);

export const sidebarTodosConfigReducer = createReducer(
    {
        // @ts-expect-error
        [actions.updateTodoFilter]: (state, payload) => {
            const todayStart = moment().startOf('day').valueOf();

            return {
                ...state,
                filter: payload,
                displayDate: todayStart,
                periodSegmentSelected: TODAY,
                periodSegmentWasManuallySelected: true,
            };
        },
        // @ts-expect-error
        [actions.updateTodoDisplayDate]: (state, payload) => {
            return {
                ...state,
                displayDate: payload.getTime(),
                lastUpdated: moment().valueOf(),
            };
        },
        // @ts-expect-error
        [actions.updatePeriodSegmentWasManuallySelected]: (state, payload) => {
            return {
                ...state,
                periodSegmentWasManuallySelected: payload ? payload : false,
            };
        },
        // @ts-expect-error
        [actions.updateTodoQueryString]: (state, payload) => {
            const todayStart = moment().startOf('day').valueOf();

            return {
                ...state,
                queryString: payload,
                displayDate: todayStart,
                periodSegmentSelected: TODAY,
                periodSegmentWasManuallySelected: true,
            };
        },
        // @ts-expect-error
        [actions.updateTodoPeriodSegmentSelected]: (state, payload) => {
            return {...state, periodSegmentSelected: payload};
        },
        // @ts-expect-error
        [REHYDRATE]: (state, persistedState) => {
            if (
                !persistedState ||
                !persistedState.dashboard ||
                !persistedState.dashboard.todosConfig
            ) {
                return state;
            }

            return {
                ...state,
                ...persistedState.dashboard.todosConfig,
                displayDate: getRehydratedValueForDateProperty(
                    persistedState.dashboard.todosConfig,
                    'displayDate'
                ),
                periodSegmentWasManuallySelected:
                    persistedState.dashboard.todosConfig.periodSegmentWasManuallySelected,
            };
        },
    },
    defaultTodosConfigState
);

export const todosReducer = createReducer(
    {
        // @ts-expect-error
        [actions.updateTodosForDay]: (state, todos) => {
            const newTodos = todos.reduce(
                // @ts-expect-error
                (newState, current) => {
                    newState[current.id] = todoReducer(
                        state.items[current.id],
                        actions.updateTodoData(current)
                    );

                    return newState;
                },
                {...state.items}
            );

            return {...state, items: newTodos};
        },
        // @ts-expect-error
        [actions.updateTodoIndices]: (state, todoIdsByIndex) => {
            const indices = Object.keys(todoIdsByIndex);
            const newTodoIndices = indices.reduce(
                (newState, index) => {
                    newState[index] = get(todoIdsByIndex, index);

                    return newState;
                },
                {...state.indices}
            );

            // @ts-expect-error
            const newTempIds = state.tempIds.filter((id) => {
                return !indices.find((index) => todoIdsByIndex[index] === id);
            });

            return {...state, indices: newTodoIndices, tempIds: newTempIds};
        },
        // @ts-expect-error
        [actions.updateTodoCounts]: (state, payload) => {
            return {...state, counts: payload};
        },
        // @ts-expect-error
        [actions.requestTodoCompleteDataById]: (state, todoId) => {
            const newTodos = {
                ...state.items,
                [todoId]: todoReducer(state.items[todoId], actions.requestTodoCompleteData()),
            } as const;

            return {...state, items: newTodos};
        },
        // @ts-expect-error
        [actions.requestTodoUncompleteDataById]: (state, todoId) => {
            const todo = state.items[todoId];

            const newTodos = {
                ...state.items,
                [todoId]: todoReducer(todo, actions.requestTodoUncompleteData()),
            } as const;
            let newTempIds = state.tempIds;
            const newCounts = {...state.counts} as const;

            // Uncompleting a step should remove the chain of subsequent steps from
            // the list as well.
            let nextStepId = todo.nextStepId;
            while (typeof nextStepId !== 'undefined') {
                const nextTodo = state.items[nextStepId];

                delete newTodos[nextStepId];
                // @ts-expect-error
                newTempIds = newTempIds.filter((id) => id !== nextStepId); // eslint-disable-line no-loop-func

                newCounts.total = newCounts.total - 1;

                const dueTime = moment.unix(nextTodo.dueTime);
                if (isBeforeToday(dueTime)) newCounts.past = newCounts.past - 1;
                else if (isToday(dueTime)) newCounts.today = newCounts.today - 1;
                else if (isTomorrow(dueTime)) newCounts.tomorrow = newCounts.tomorrow - 1;
                else if (isAfterTomorrow(dueTime)) newCounts.future = newCounts.future - 1;

                nextStepId = nextTodo.nextStepId;
            }

            return {...state, counts: newCounts, tempIds: newTempIds, items: newTodos};
        },
        // @ts-expect-error
        [actions.requestTodoSkipDataById]: (state, todoId) => {
            const newTodos = {
                ...state.items,
                [todoId]: todoReducer(state.items[todoId], actions.requestTodoSkipData()),
            } as const;

            return {...state, items: newTodos};
        },
        // @ts-expect-error
        [actions.requestTodoDelayDataById]: (state, todoId) => {
            const newTodos = {
                ...state.items,
                [todoId]: todoReducer(state.items[todoId], actions.requestTodoDelayData()),
            } as const;

            return {...state, items: newTodos};
        },
        // @ts-expect-error
        [actions.updateTodoDataById]: (state, todo) => {
            const todoAlreadyExists = state.items[todo.id];

            // If the todo was deleted, we need to remove it from the store.
            // Unfortunately we can't just request a new list from the server right away,
            // because it needs some time to reindex, which can take up to 5 seconds.
            if (todo.deletedTime) {
                // Remove deleted todo from items
                const newTodos = _.omit(state.items, todo.id);

                // Also remove todo from temporary ids
                const newTempIds = _.without(state.tempIds, todo.id);

                // Calculate new indices
                const indexToRemove = _.findKey(state.indices, (x) => x === todo.id);

                const newIndices =
                    typeof indexToRemove !== 'undefined'
                        ? removeItemAndShiftIndices(state.indices, indexToRemove)
                        : {...state.indices};

                // Calculate new counts
                const newCounts = {...state.counts, total: state.counts.total - 1} as const;
                const dueTime = moment.unix(todo.dueTime);
                if (isBeforeToday(dueTime)) newCounts.past = newCounts.past - 1;
                else if (isToday(dueTime)) newCounts.today = newCounts.today - 1;
                else if (isTomorrow(dueTime)) newCounts.tomorrow = newCounts.tomorrow - 1;
                else if (isAfterTomorrow(dueTime)) newCounts.future = newCounts.future - 1;

                return {
                    ...state,
                    items: newTodos,
                    indices: newIndices,
                    counts: newCounts,
                    tempIds: newTempIds,
                };
            } else {
                // If the todo is not deleted, update its details
                const newTodos = {
                    ...state.items,
                    [todo.id]: todoReducer(state.items[todo.id], actions.updateTodoData(todo)),
                } as const;

                if (todoAlreadyExists) {
                    return {...state, items: newTodos};
                } else {
                    const tempIds = state.tempIds.concat([todo.id]);
                    const newCounts = {...state.counts, total: state.counts.total + 1} as const;
                    const dueTime = moment.unix(todo.dueTime);
                    if (isBeforeToday(dueTime)) newCounts.past = newCounts.past + 1;
                    else if (isToday(dueTime)) newCounts.today = newCounts.today + 1;
                    else if (isTomorrow(dueTime)) newCounts.tomorrow = newCounts.tomorrow + 1;
                    else if (isAfterTomorrow(dueTime)) newCounts.future = newCounts.future + 1;

                    return {
                        ...state,
                        items: newTodos,
                        tempIds: tempIds,
                        counts: newCounts,
                    };
                }
            }
        },
        // @ts-expect-error
        [actions.failTodoCompleteDataById]: (state, {id, errorMessage}) => {
            const newTodos = {
                ...state.items,
                [id]: todoReducer(state.items[id], actions.failTodoCompleteData(errorMessage)),
            } as const;

            return {...state, items: newTodos};
        },
        // @ts-expect-error
        [actions.failTodoUncompleteDataById]: (state, {id, errorMessage}) => {
            const newTodos = {
                ...state.items,
                [id]: todoReducer(state.items[id], actions.failTodoUncompleteData(errorMessage)),
            } as const;

            return {...state, items: newTodos};
        },
        // @ts-expect-error
        [actions.failTodoSkipDataById]: (state, {id, errorMessage}) => {
            const newTodos = {
                ...state.items,
                [id]: todoReducer(state.items[id], actions.failTodoSkipData(errorMessage)),
            } as const;

            return {...state, items: newTodos};
        },
        // @ts-expect-error
        [actions.failTodoDelayDataById]: (state, {id, errorMessage}) => {
            const newTodos = {
                ...state.items,
                [id]: todoReducer(state.items[id], actions.failTodoDelayData(errorMessage)),
            } as const;

            return {...state, items: newTodos};
        },
        // @ts-expect-error
        [actions.clearTodoErrorById]: (state, todoId) => {
            const newTodos = {
                ...state.items,
                [todoId]: todoReducer(state.items[todoId], actions.clearTodoError()),
            } as const;

            return {...state, items: newTodos};
        },
        // @ts-expect-error
        [actions.updateTodoFilter]: (state) => {
            return {...state, indices: {}, items: {}, counts: {}, tempIds: []};
        },
        // @ts-expect-error
        [actions.updateTodoQueryString]: (state) => {
            return {...state, indices: {}, items: {}, counts: {}, tempIds: []};
        },
        // @ts-expect-error
        [REHYDRATE]: (state, persistedState) => {
            if (!persistedState || !persistedState.dashboard || !persistedState.dashboard.todos)
                return state;

            return {
                ...state,
                counts: persistedState.dashboard.todos.counts,
            };
        },
    },
    defaultTodosState
);
